import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import StatCardStyles from '../../styles/StatCard';
import { Icon } from '@material-ui/core';

const StatCard = (props) => {
    const { classes, type, title, value, icon, color, onClick } = props;

    let before = null;
    let after = null;

    const cardIcon = (
        <Grid item className={type === 'fill' ? classes.iconFloat : classes.icon}>
            <span
                style={{
                    display: 'inline-flex',
                    color: type === 'fill' ? '#fff' : '#000',
                    lineHeight: 0,
                }}
            >
                {icon}
            </span>
        </Grid>
    );

    if (icon) {
        type === 'fill' ? (after = cardIcon) : (before = cardIcon);
    }

    const hasValue = value != null && value !== '';

    return (
        <Card
            onClick={onClick}
            className={classes.root}
            style={type === 'fill' ? { backgroundColor: color } : null}
        >
            <CardContent className={classes.content}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    wrap="nowrap"
                    spacing={0}
                >
                    <Grid item xs style={{ minWidth: 0, maxWidth: '100%' }}>
                        <Grid
                            container
                            alignItems="center"
                            direction="row"
                            justify="flex-start"
                            wrap="nowrap"
                            spacing={0}
                        >
                            {before}
                            <Grid item xs style={{ minWidth: 0 }}>
                                <div className={type === 'fill' ? 'pr-1' : 'px-1'}>
                                    <Typography
                                        variant="headline"
                                        className={
                                            type === 'fill'
                                                ? `${classes.lightText} ${classes.title}`
                                                : classes.title
                                        }
                                    >
                                        {title}
                                    </Typography>
                                </div>
                            </Grid>
                            {after}
                        </Grid>
                    </Grid>
                    <Grid item className={classes.value}>
                        <Typography
                            variant="h5"
                            className={`${classes.valueText} ${
                                type === 'fill' ? classes.lightText : ''
                            }`}
                        >
                            {hasValue ? <span style={{ marginRight: 4 }}>{value}</span> : null}
                            <Icon style={{ fontSize: '18px' }}>navigate_next</Icon>
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

StatCard.propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.oneOf(['fill']),
    title: PropTypes.string,
    value: PropTypes.number,
    icon: PropTypes.element,
    color: PropTypes.string,
};

StatCard.defaultProps = {
    IconColor: 'white',
    color: 'white',
};

export default withStyles(StatCardStyles)(StatCard);
